module.exports = __webpack_public_path__ + "static/media/00_paint_agd-thaiti.6f240462.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/00_paint_agd-thaiti.jpg
// module id = 271
// module chunks = 0